import { render, staticRenderFns } from "./nested-test.vue?vue&type=template&id=7738a73d&scoped=true&"
import script from "./nested-test.vue?vue&type=script&lang=js&"
export * from "./nested-test.vue?vue&type=script&lang=js&"
import style0 from "./nested-test.vue?vue&type=style&index=0&id=7738a73d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7738a73d",
  null
  
)

export default component.exports